import { render } from "./BookingCardComp.vue?vue&type=template&id=5e2dc2fc"
import script from "./BookingCardComp.vue?vue&type=script&lang=js"
export * from "./BookingCardComp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__